export default function(t = 0) {
    const sec = appendZero(Number.parseInt(t % 60)),
        min = appendZero(Number.parseInt((t / 60) % 60));
    return `${min}:${sec}`;
}

const appendZero = n => n.toLocaleString({}, { minimumIntegerDigits: 2 });
